import React, { useEffect, useMemo, useRef, useState } from "react";
import { ExternalLink } from "lucide-react";

import "./PdfContentViewer.css";

export default function PdfContentViewer({ content, fileUrl, progress, onTrack, onContextChange, navigationRequest }) {
    const [currentPage, setCurrentPage] = useState(1);
    const progressPercentRef = useRef(Math.max(Number(progress?.progressPercent || 0), 5));
    const handledNavigationRef = useRef(null);
    const savedPage = Math.max(1, Number(progress?.progressPayload?.currentPage || 1));
    const pdfSrc = useMemo(() => {
        if (!fileUrl) {
            return null;
        }
        return `${fileUrl}#page=${currentPage}`;
    }, [currentPage, fileUrl]);
    const viewerKey = `${content?.id || "content"}-${fileUrl || "file"}-${currentPage}`;

    useEffect(() => {
        setCurrentPage(savedPage);
    }, [content?.id, fileUrl, savedPage]);

    useEffect(() => {
        onContextChange?.({
            contentTypeContext: "PDF",
            pdfPage: currentPage,
        });
    }, [currentPage, onContextChange]);

    useEffect(() => {
        const requestId = navigationRequest?.requestId;
        const page = navigationRequest?.pdfPage;
        if (!requestId || page == null || handledNavigationRef.current === requestId) return;
        handledNavigationRef.current = requestId;
        setCurrentPage(Math.max(1, Number(page || 1)));
    }, [navigationRequest]);

    useEffect(() => {
        progressPercentRef.current = Math.max(Number(progress?.progressPercent || 0), 5);
    }, [content?.id, progress?.progressPercent]);

    useEffect(() => {
        const timerId = window.setInterval(() => {
            if (!document.hidden) {
                onTrack?.({
                    timeSpentDeltaSeconds: 1,
                    completionPercent: progressPercentRef.current,
                    progressPayload: {},
                });
            }
        }, 1000);

        return () => window.clearInterval(timerId);
    }, [content?.id, onTrack]);

    return (
        <div className="pcv-wrap">
            <object key={viewerKey} className="cr-frame" data={pdfSrc} type={content.mimeType || "application/pdf"}>
                <iframe key={`${viewerKey}-frame`} className="cr-frame" title={content.title} src={pdfSrc} />
            </object>
        </div>
    );
}
